export const POWERED_BY_MONDAY = { url: '/assets/powered-by/powered-by.png', height: 17 };
